// This file will house pure functional utilities specific to tracking/date formatting.

// --- 1. Calendar Generator ---
export const generateCalendarDays = (centerDate) => {
    const year = centerDate.getFullYear();
    const month = centerDate.getMonth();
    const firstDayOfMonth = new Date(year, month, 1);
    const startingDayOfWeek = firstDayOfMonth.getDay(); 
    const startDate = new Date(firstDayOfMonth);
    startDate.setDate(startDate.getDate() - startingDayOfWeek);
    const days = [];
    for (let i = 0; i < 42; i++) {
        const d = new Date(startDate);
        d.setDate(d.getDate() + i);
        days.push(d);
    }
    return days;
};

// --- 2. Format Date (Copied from utils/finance context for consistency) ---
export const formatDate = (dateInput) => {
    if (!dateInput) return "";
    if (dateInput instanceof Date) {
        return dateInput.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
    }
    if (typeof dateInput === 'string') {
        const cleanDate = dateInput.split('T')[0]; 
        if(cleanDate.includes('-')) {
            const [y, m, d] = cleanDate.split('-').map(Number);
            const dateObj = new Date(y, m - 1, d); 
            return dateObj.toLocaleDateString('en-US', { month: 'short', day: 'numeric' });
        }
    }
    return "";
};

// --- 3. Format Future Date (Used in DebtTab calculations) ---
export const formatFutureDate = (months) => {
    if (!months || months <= 0) return "Paid Off";
    if (months >= 600) return "Never";
    const d = new Date();
    d.setMonth(d.getMonth() + months);
    return d.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
};

// --- 4. Local Date String (Internal Helper for comparisons in hooks) ---
export const toLocalDateStr = (dateObj) => {
    if (!dateObj) return "";
    const year = dateObj.getFullYear();
    const month = String(dateObj.getMonth() + 1).padStart(2, '0');
    const day = String(dateObj.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
};